import Cards from './card/components'
import formatDate from '@/module/util/format-date'
import formatDateTime from '@/module/util/format-date-time'

export default {
	props: {
		patient: {
			type: Object,
			required: true
		}
	},

	methods: {
		formatDate,
		formatDateTime
	},

	components: {
		...Cards
	}
}
